<template>
  <button class="unstyled-btn d-flex align-items-center" :class="['wc-chip', 'p-2', chipVariant]">
    {{ text }}
    <font-awesome-icon
      :icon="icon"
      :size="size"
      :color="color"
      class="ml-2"
      :title="$t('removeFromFilter')"
      :aria-label="$t('removeFromFilter')"
    />
  </button>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: Array || String,
      default: () => ['fa', 'xmark'],
    },
    size: {
      type: String,
      default: '1x',
    },
    color: {
      type: String,
      default: 'white',
    },
    chipVariant: {
      type: String,
      default: 'primary',
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-chip {
  cursor: pointer;
  border-radius: 5px;
  line-height: initial;

  &.primary {
    background-color: var(--primary, $primary);
    color: var(--primary-contrast, get-color-contrast('primary'));
  }
  &.secondary {
    background-color: var(--secondary, $secondary);
    color: var(--secondary-contrast, get-color-contrast('secondary'));
  }
}
</style>
